import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { AppointmentRequestForm } from "./appointment-request/AppointmentRequestForm";
import { AppointmentRequestActions } from "./appointment-request/AppointmentRequestActions";
import { useAppointmentRequest } from "./appointment-request/useAppointmentRequest";
import { AppointmentRequestDialogProps } from "./appointment-request/types";

export const AppointmentRequestDialog = ({ 
  open, 
  onOpenChange, 
  serviceId,
  professionalId,
  serviceName
}: AppointmentRequestDialogProps) => {
  const { form, isLoading, onSubmit } = useAppointmentRequest(
    serviceId,
    professionalId,
    onOpenChange
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px] h-[90vh]">
        <DialogHeader>
          <DialogTitle>
            Prendre rendez-vous - {serviceName}
          </DialogTitle>
        </DialogHeader>
        <ScrollArea className="h-full pr-4">
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <AppointmentRequestForm form={form} />
            <AppointmentRequestActions
              onCancel={() => onOpenChange(false)}
              isLoading={isLoading}
            />
          </form>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};